import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  validateEmail,
  validatePasswordLowercase,
  validatePasswordNumber,
  validatePasswordSpecialCharacter,
  validatePasswordUpperCase,
} from "../../helper/helpers";
import AuthLayoutIndex from "../../layout/auth/AuthLayoutIndex";
import RootState from "../../redux/type";
import {
  confirmInvitedAdminFunc,
  verifyInvitedAdmin,
} from "../../redux/userAuth";
import { ALL_ROUTES } from "../../routes/AllRoutes";
import "../../styles/auth/Login.css";
import ConfirmSignUpModal from "./modals/ConfirmSignUpModal";
import { toast } from "../../components/razor-reuse/toast/RazorToast";
import RazorInputField from "../../components/razor-reuse/inputField/RazorInputField";

const SignUp = () => {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state: RootState) => state.auth);
  type modalProps = {
    confirm: boolean;
  };
  const [showModal, setShowModal] = useState<modalProps>({
    confirm: false,
  });

  type errorProps = {
    email: string;
    password: string;
  };

  const [error, setError] = useState<errorProps>({
    email: "",
    password: "",
  });

  type detailsProps = {
    email: string;
    password: string;
    password_confirmation: string;
  };

  const [details, setDetails] = useState<detailsProps>({
    email: "",
    password: "",
    password_confirmation: "",
  });

  const handleChange = (e: any) => {
    e && e.preventDefault();
    const { name, value } = e?.target;

    const obj = { ...details, [name]: value };
    setDetails(obj);
  };

  const handleNextStep = () => {
    if (step === 1) {
      verifyEmailFunc();
    } else {
    }
  };

  const verifyEmailFunc = async () => {
    const obj = { email: details?.email };
    const data = await dispatch(verifyInvitedAdmin(obj) as any);
    if (data?.payload?.data?.status) {
      // toast.success(data?.payload?.data?.message);
      setStep(2);
    }
    if (data?.payload?.response?.data?.status === "failed") {
      const messg = data?.payload?.response?.data?.errors?.email;
      toast.error(messg);
    }
  };

  const confirmInvitedAdmin = async () => {
    if (!validatePasswordLowercase(details.password)) {
      toast.error("Password should have at least 1 lowercase letter");
      return;
    }
    if (!validatePasswordUpperCase(details.password)) {
      toast.error("Password should have at least 1 capital letter");
      return;
    }
    if (!validatePasswordSpecialCharacter(details.password)) {
      toast.error("Password should have at least 1 special character");
      return;
    }
    if (!validatePasswordNumber(details.password)) {
      toast.error("Password should have at least  1 numeric character.");
      return;
    }
    if (details?.password !== details?.password_confirmation) {
      toast.error("Passwords does not match!!!");
      return;
    }
    const obj = { ...details };
    const data = await dispatch(confirmInvitedAdminFunc(obj) as any);
    if (data?.payload?.data?.status) {
      setDetails((prev) => {
        return { ...prev, email: "", password: "", password_confirmation: "" };
      });
      setShowModal((prev) => {
        return { ...prev, confirm: true };
      });
    }
    if (data?.payload?.response?.data?.status === "failed") {
      // const messg = data?.payload?.response?.data?.errors?.email;
      // toast.error(messg);
    }
  };

  return (
    <>
      <AuthLayoutIndex
        text={
          step === 1
            ? ""
            : `Password should contain: Uppercase and \n lowercase letters, numbers, symbols`
        }
        title={
          step === 1
            ? "Input your official email"
            : "Time to set a secure password"
        }
        back={step === 2}
        onBack={() => {
          setStep(1);
        }}
      >
        <div className="auth-login-wrapper-box">
          <form
            action=""
            onSubmit={(e) => {
              e.preventDefault();
              handleNextStep();
            }}
            className="form"
            autoComplete="off"
          >
            {/* step one start */}
            {step === 1 && (
              <>
                {" "}
                <RazorInputField
                  placeholder="Input Email"
                  color="black-light"
                  type="email"
                  label="Email"
                  errorText={error?.email}
                  showError={error?.email ? true : false}
                  value={details?.email}
                  name="email"
                  onChange={(e: any) => {
                    error?.email &&
                      setError((prev) => {
                        return { ...prev, email: "" };
                      });
                    handleChange(e);
                  }}
                />
                <RazorInputField
                  className="submit-btn"
                  color="black-light"
                  type="submit"
                  value={`Get Started`}
                  disabled={!details?.email || !validateEmail(details.email)}
                  onSubmit={() => {
                    if (!validateEmail(details?.email)) {
                      setError((prev) => {
                        return { ...prev, email: "Invalid email address!" };
                      });
                      return;
                    } else {
                      handleNextStep();
                    }
                  }}
                  loading={loading}
                />
              </>
            )}
            {/* step one end */}
            {/* step two start */}
            {step === 2 && (
              <>
                <RazorInputField
                  color="black-light"
                  type="password"
                  label="Set Password"
                  showPasswordStrength={true as any}
                  style={{ position: "relative", zIndex: 10 }}
                  value={details?.password}
                  name="password"
                  onChange={handleChange}
                  placeholder="Enter password"
                />
                <RazorInputField
                  color="black-light"
                  type="password"
                  label="Confirm Password"
                  value={details?.password_confirmation}
                  name="password_confirmation"
                  onChange={handleChange}
                  placeholder="Enter confirm password"
                />
                <RazorInputField
                  className="submit-btn"
                  color="black-light"
                  type="submit"
                  value={`Set Password`}
                  disabled={
                    !details?.email ||
                    !details?.password ||
                    !details?.password_confirmation
                  }
                  onSubmit={confirmInvitedAdmin}
                  loading={loading}
                />
              </>
            )}
            {/* step two end */}
          </form>
          {/* dont have account start */}
          <div style={{ marginTop: "3rem" }} className="down-text-box">
            <p className="text">
              Have an account?{" "}
              <span
                onClick={() => {
                  navigate(ALL_ROUTES?.LOGIN);
                }}
              >
                Login
              </span>
            </p>
          </div>
          {/* dont have account end */}
        </div>
      </AuthLayoutIndex>
      {/* modal start */}
      <ConfirmSignUpModal
        visible={showModal?.confirm}
        onClose={() => {
          setStep(1);
          setShowModal((prev) => {
            return { ...prev, confirm: false };
          });
        }}
      />
      {/* modal end */}
    </>
  );
};

export default SignUp;
